const Login = `query Login($email: String!, $pass: String!){
        login(email:$email, pass:$pass){
            token
        }
    }`
export default Login;